import React, { FC } from 'react';
import {
  IconWashingMachine,
  IconGroup,
  IconClock,
  IconMapPin,
  IconBuilding,
} from '../icons';
import { ResourceType } from '../../utils/calendar';

interface ResourceIconProps {
  type: ResourceType;
  className?: string;
}

export const ResourceIcon: FC<ResourceIconProps> = ({ type, className }) => {
  switch (type) {
    case ResourceType.Laundry:
      return <IconWashingMachine className={className} />;
    case ResourceType.Gym:
      return <IconGroup className={className} />;
    case ResourceType.MeetingRoom:
      return <IconClock className={className} />;
    case ResourceType.Storage:
      return <IconMapPin className={className} />;
    case ResourceType.Other:
    default:
      return <IconBuilding className={className} />;
  }
};
